"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/typography/style");
var _typography = _interopRequireDefault(require("antd/lib/typography"));
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _ = require("../..");
var _constants = require("../../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var Title = _typography.default.Title,
  Paragraph = _typography.default.Paragraph;
var YouAreBannedNotification = function YouAreBannedNotification(_ref) {
  var publicChatBan = _ref.publicChatBan,
    globalBan = _ref.globalBan,
    channelBan = _ref.channelBan;
  var banExpiration = (publicChatBan === null || publicChatBan === void 0 ? void 0 : publicChatBan.expiration) || (channelBan === null || channelBan === void 0 ? void 0 : channelBan.expiration) || (globalBan === null || globalBan === void 0 ? void 0 : globalBan.expiration);
  return /*#__PURE__*/_react.default.createElement(_.DynamicHeightCubby.Prompt, {
    visible: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__banned-notification"
  }, /*#__PURE__*/_react.default.createElement(Title, {
    level: 4
  }, "You have been banned", ' ', publicChatBan || globalBan ? 'from all support channels' : 'from this channel', banExpiration ? " until ".concat((0, _momentTimezone.default)(banExpiration).format('MMMM, DD YYYY, hh:mm A, z')) : ''), /*#__PURE__*/_react.default.createElement(Paragraph, null, "You have violated the terms, conditions, or guidelines for this Support Group. If you think this is a mistake or want to rejoin, please contact our customer support."), /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "link",
    href: _constants.SUPPORT_URL,
    target: "_blank",
    rel: "noopener noreferrer"
  }, "Contact Support")));
};
var _default = YouAreBannedNotification;
exports.default = _default;